import React from 'react'
import { WrappedFieldProps } from 'redux-form'
import JobFinishesDrawer from './JobFinishesDrawer'

interface OwnProps {
	label: string
	jobID: number
	numberOfMonths?: number
	defaultStringValue?: string
	disabled?: boolean
}

type Props = WrappedFieldProps & OwnProps

const JobFinishesDrawerField: React.FC<Props> = ({
	input, label, jobID, numberOfMonths, defaultStringValue, disabled
}) => (
	<div className="mb-4">
		<label className="ant-form-item-label">
			<span className={'font-semibold'}>{label}</span>
		</label>
		<JobFinishesDrawer
			jobID={jobID}
			numberOfMonths={numberOfMonths}
			selectedFinishId={input.value}
			defaultStringValue={defaultStringValue}
			disabled={disabled}
			onSelectFinish={(finishId: number) => input.onChange(finishId)}
		/>
	</div>
)

export default JobFinishesDrawerField
